export const RENT_TYPES = {
    1: "diario",
    2: "semanal",
    3: "quincenal",
    4: "mensual"
};